<template>
  <div class="paginacion">
    <div class="btn-group">
      <button v-if="currentPage > 1" type="button" class="btn btn-info btn-micro" @click="backPage">&laquo;
      </button>
      <button type="button" disabled class="btn btn-micro btn-warning btn-outline-secondary">Página:
        {{currentPage}}
      </button>
      <button type="button" class="btn btn-info btn-micro" @click="nextPage">&raquo;</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "paginacion",
    props: ['currentPage'],
    methods: {
      nextPage() {
        this.$emit('next')
      },
      backPage() {
        this.$emit('back')
      }
    }
  }
</script>

<style scoped>

</style>
